var Backbone, EmailFormIntlFlexibleContactChannelsView, SupportFlexibleContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFlexibleContactChannelsTemplate = require('../../../../flexible_contact_channels.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlFlexibleContactChannelsView = (function(superClass) {
  extend(EmailFormIntlFlexibleContactChannelsView, superClass);

  function EmailFormIntlFlexibleContactChannelsView() {
    return EmailFormIntlFlexibleContactChannelsView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlFlexibleContactChannelsView.prototype.className = 'flexible-contact-channels-view';

  EmailFormIntlFlexibleContactChannelsView.prototype.events = {
    'DOMSubtreeModified .flex-primary-chat-button#live-chat-container': 'handleDisplayOfPrimaryLiveChat',
    'DOMSubtreeModified .primary-chat-link#live-chat-link-container': 'handleDisplayOfPrimaryLiveChatLink',
    'DOMSubtreeModified .secondary-chat-link#live-chat-link-container': 'handleDisplayOfSecondaryLiveChatLink',
    'DOMSubtreeModified .tertiary-chat-link#live-chat-link-container': 'handleDisplayOfTertiaryLiveChatLink',
    'click .flex-primary-email-button': 'renderEmailForm',
    'click .flex-primary-phone-button': 'renderPhoneView',
    'click .flex-email-link': 'renderEmailForm',
    'click .flex-phone-link': 'renderPhoneView'
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportFlexibleContactChannelsTemplate;
    this.model = Groupon.Support.FlexibleContactChannelModel;
    return this.mainView = this.options.mainView;
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.render = function() {
    this.model.presentContactChannels();
    this.$el.empty();
    this.$el.append(toHtml(this.template, this.toHash({
      renderLayout: true,
      withoutChat: !this.isLiveChatEnabled()
    }), this.I18nScope));
    this.handleDisplayOfChannelsWithMoreSpace();
    return this;
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.LiveChatModel.isLiveChatEnabled();
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.renderEmailForm = function(e) {
    return this.mainView.renderEmailForm();
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.renderPhoneView = function() {
    return this.mainView.renderPhoneNumberView();
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfChannelsWithMoreSpace = function() {
    if (window.evaluate(window.experiments.showFlexibleContactChannelsWithMoreSpace)) {
      this.$el.addClass('flexible-contact-channels-view-with-more-space');
      this.$el.find('.flex-primary-button').addClass('flex-primary-button-text-with-more-space');
      return this.$el.find('.flex-primary-chat-button').addClass('flex-primary-button-text-with-more-space');
    }
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfPrimaryLiveChat = function() {
    this.$el.find('.flex-contact-channels-without-chat').empty();
    this.setFlexibleLiveChatDisplayCallBack(this.handleDisplayOfPrimaryLiveChat);
    if (this.flexiblePrimaryLiveChatVisible()) {
      window.showDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      return window.hideDOMElems($('.flex-contact-channels-without-chat'));
    } else {
      window.hideDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      window.showDOMElems($('.flex-contact-channels-without-chat'));
      $('.flex-contact-channels-without-chat').append(toHtml(this.template, this.toHash({
        withoutChat: true
      }), this.I18nScope));
      return this.handleDisplayOfChannelsWithMoreSpace();
    }
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfPrimaryLiveChatLink = function() {
    var primaryChatTextElem;
    primaryChatTextElem = $(".flex-primary-channel-text");
    return this.toggleDomElemsBasedOnLiveChat(primaryChatTextElem);
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfSecondaryLiveChatLink = function() {
    var DOMelemsToToggle, flexTertiaryOrTextElem, secondaryFlexibleLiveChatContainerElem;
    secondaryFlexibleLiveChatContainerElem = $('.secondary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    DOMelemsToToggle = [secondaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem];
    if (this.model.get('formattedContactChannels').contact_channels.length === 2) {
      DOMelemsToToggle.push($('.flex-secondary-channel-also-text'));
    }
    return this.toggleDomElemsBasedOnLiveChat(DOMelemsToToggle);
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfTertiaryLiveChatLink = function() {
    var flexTertiaryOrTextElem, tertiaryFlexibleLiveChatContainerElem;
    tertiaryFlexibleLiveChatContainerElem = $('.tertiary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    return this.toggleDomElemsBasedOnLiveChat([tertiaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]);
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.toggleDomElemsBasedOnLiveChat = function(domElems) {
    if (window.liveChatLinkVisible()) {
      return window.showDOMElemsInline(domElems);
    } else {
      window.removeDOMElemsInline(domElems);
      return window.hideDOMElems(domElems);
    }
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.setFlexibleLiveChatDisplayCallBack = function(liveChatDisplayCallback) {
    return window.setLiveChatDisplayCallBack($('.flexible-contact-channels-container #live-chat-container a img'), liveChatDisplayCallback);
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.flexiblePrimaryLiveChatVisible = function() {
    return window.liveChatVisible($('.flexible-contact-channels-container #live-chat-container a img'));
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.handleDisplayOfContactChannels = function() {
    if ($('.flex-primary-chat-button#live-chat-container').length > 0) {
      return this.handleDisplayOfPrimaryLiveChat();
    }
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.toHash = function(arg) {
    var hash, renderLayout, withoutChat;
    withoutChat = arg.withoutChat, renderLayout = arg.renderLayout;
    hash = {};
    if (withoutChat) {
      hash = this.model.get('contactChannelsWithoutBoldChat');
    } else if (this.model.has('formattedContactChannels')) {
      hash = this.model.get('formattedContactChannels');
    } else {
      hash = this.model.get('contactChannelsWithoutBoldChat');
    }
    if (renderLayout) {
      hash = $.extend(true, {
        renderLayout: true
      }, hash);
    }
    return hash;
  };

  EmailFormIntlFlexibleContactChannelsView.prototype.renderLiveChat = function() {
    var ref;
    if ((ref = this.model) != null ? ref.get('liveChatExists') : void 0) {
      if (this.model.get("primaryChannelIsBoldChat")) {
        this.mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleLiveChatType()
        });
      }
      return this.mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: this.model.get("primaryChannelIsBoldChat")
      });
    } else {
      return this.mainView.renderLiveChat({
        liveChatMode: 'static'
      });
    }
  };

  return EmailFormIntlFlexibleContactChannelsView;

})(Backbone.View);

module.exports = EmailFormIntlFlexibleContactChannelsView;

//# sourceMappingURL=data:application/json;base64,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
